// Centralized label mappings for consistent UI display across all apps

// Property type labels
export const PROPERTY_TYPE_LABELS = {
  detached_house: 'Omakotitalo',
  semi_detached: 'Paritalo',
  row_house: 'Rivitalo',
  apartment_building: 'Kerrostalo',
  commercial_property: 'Liikekiinteistö',
} as const

// Customer type labels
export const CUSTOMER_TYPE_LABELS = {
  household: 'Kotitalous',
  company: 'Yritys',
} as const

// Customer status labels
export const CUSTOMER_STATUS_LABELS = {
  active: 'Aktiivinen',
  paused: 'Tauolla',
  churned: 'Lopettanut',
} as const

// User role labels
export const USER_ROLE_LABELS = {
  user: 'Asukas',
  employee: 'Työntekijä',
  officer: 'Toimihenkilö',
  admin: 'Admin',
} as const
